import React, {useContext, useEffect} from 'react';
import {Controller, useFormContext, useWatch} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {FormFieldConfigSize, FormFieldOption} from '@src/@types/components/Form';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import CustomSelect from '@src/components/Fields/CustomSelect';
import classnames from '@src/helpers/classnames';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import {IPurchaseModel} from '@src/@interfaces/models/Purchase/IPurchaseModel';

export function MaterialField({rowIndex: index, ...props}: IListColumnProps) {
    const {
        fieldName,
        modelOptions = {},
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IPurchaseModel> | null>(FormFieldItemPropsContext) ?? {};
    const {control, setValue} = useFormContext<IPurchaseModel>();
    const [design] = useContext(FormFieldDesignContext);

    const name = `${fieldName}.${index}.${props.config.name}`;
    const materials = modelOptions.materials as (FormFieldOption & { price_for_unit: number })[] | undefined;
    const value = useWatch({control, name});

    useEffect(() => {
        if (!materials || !value) {
            return;
        }

        const itemPrice = materials.find(item => item.value === value)?.price_for_unit;
        if (itemPrice) {
            setValue(`${fieldName}.${index}.price`, itemPrice / 100);
        }
    }, [fieldName, index, materials, setValue, value]);

    return <>
        <Controller
                control={control}
                name={name}
                render={({field: {name, value, onChange, onBlur}, fieldState: {invalid}}) => {
                    return <CustomSelect
                            label={props.config.label ?? ''}
                            className={classnames({
                                'is-invalid': invalid
                            })}
                            isInvalid={invalid}
                            name={name}
                            size={FormFieldConfigSize.SM}
                            options={materials}
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            menuPortalTarget={document.body}
                    />;
                }}
        />

        <FormErrorMessage fieldName={name}/>
    </>;
}
